import { Data } from "@cirrus/fe-lib"

import { Customer as params } from "./_params.js"
import { CustomerModel } from "./model/index.js"

export const Customer = Data.merged(CustomerModel, {
  params,
  domain: params.domain,
})
